import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Button, Checkbox, Dropdown, Page, Tile} from '../../../shared';
import PropTypes from 'prop-types';
import {_openModal} from '../../../shared/reducers/modals';
import {gatherData, getUpdatedFilter} from '../../../shared/utils/utils';
import DocumentVault from '../../../shared/pages/DocumentVault';

const gatherDocuments = gatherData('/documents/library');

const Documents = props => {
  const {session, openModal} = props;

  const [filters, setFilters] = useState({});
  const [defaultParams, setDefaultParams] = useState({shareApproval: ['!DENIED']});

  const dataManager = {
    gatherData: inputValue => gatherDocuments({
      ...getUpdatedFilter(defaultParams),
      ...getUpdatedFilter(filters),
      ...inputValue,
    }),
  };

  const updateFilter = (name, value) => {
    setFilters({
      ...filters,
      [name]: value,
    });

    dataManager.refresh();
  };

  const updateParams = (name, value) => {
    setDefaultParams({
      ...defaultParams,
      [name]: value,
    });

    dataManager.refresh();
  };

  const tableFilters = [
    <Checkbox
      key={'includeDenied'}
      title={'Include Denied'}
      dataPoint={{
        name: 'shareApproval',
        value: !(defaultParams.shareApproval.includes('!DENIED')),
      }}
      onChange={(name, value) => {
        updateParams(name, value && [] || ['!DENIED']);
      }}
      disabled={false}/>,
    <Checkbox
      key={'new'}
      title={'New'}
      dataPoint={{
        name: 'isNew',
        value: !!(filters.isNew),
      }}
      onChange={(name, value) => {
        updateFilter(name, !value ? null : 1);
      }}
      disabled={false}/>,
    <Dropdown
      key={'isShared'}
      title={'Share Status'}
      placeholder={'Select Share Status'}
      type={'dropdown'}
      dataPoint={{
        name: 'isShared',
      }}
      options={[{label: 'Shared', value: 1}, {label: 'Not Shared', value: 0}]}
      onChange={updateFilter}
      isClearable/>,
  ];

  const tableIconKeys = [
    {
      title: 'Recent Approval',
      image: 'checkMarkCircleO',
      color: '#99FA66',
      description: 'The content was recently approved for sharing with households.',
      category: 'Share Status',
      displayCondition: d => !!d.recentlyApproved,
    },
    {
      title: 'Recent Denial',
      image: 'exclamationCircle',
      color: '#E8BA08',
      description: 'The content was recently denied from being shared with households.',
      category: 'Share Status',
      displayCondition: d => !!d.recentlyDenied,
    },
    {
      title: 'Pending Approval',
      image: 'hourglass',
      color: '#7D84C0',
      description: 'The content was recently attempted to be shared with households and is still pending review.',
      category: 'Share Status',
      displayCondition: d => !!d.pendingApproval,
    },
    {
      title: 'Past Approval',
      image: 'checkMarkCircleO',
      color: '#9B9B9B',
      description: 'The content has previously been approved and shared with households.',
      category: 'Share Status',
      displayCondition: d => !!d.previouslyApproved && !d.recentlyApproved,
    },
    {
      title: 'New Content',
      image: 'dotNew',
      color: '#00D0BE',
      description: 'The content has newly been added to the library.',
      category: 'General',
      displayCondition: d => !!d.isNew,
    },
  ];

  return (
    <Page>
      <Tile key='Documents' title='Documents'>
        <Button importance={'secondary'}
                size={'md'}
                label={'Add'}
                disabled={false}
                action={() => openModal({
                  componentName: 'AddDocument',
                  refreshPage: () => dataManager.refresh(),
                })}/>
        <DocumentVault openModal={openModal}
                       session={session}
                       dataManager={dataManager}
                       dataFilters={filters}
                       tableFilters={tableFilters}
                       tableIconKeys={tableIconKeys}/>
      </Tile>
    </Page>
  );
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Documents);

Documents.propTypes = {
  /**
   * Is Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.shape({id: PropTypes.number.isRequired})}).isRequired,
  /**
   * The open function that dispatches _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
};
